module.exports = __webpack_public_path__ + "static/img/ls7.6181c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls7.png
// module id = oq1O
// module chunks = 12